import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
// import * as $ from 'jquery';
import $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class FreeFormCommonService {

  constructor(private utilService: UtilityService) { }
  //Method to fetch agenda duration 
  trimAgendaDuration(obj: any) {
    if ($(obj).find(".agDurCls").length != 0) {
      var agDurationTxt = "";
      var jHtmlObject = $(($(obj).find(".agDurCls:last")[0].outerHTML).replace(/[\u200B-\u200D\uFEFF\u200E\u200F]/g, '').replace(/\t/g, '').replace(/\n/g, ''));
      var tempTxt = $("<p>").append(jHtmlObject);
      tempTxt.find(".agDurLabelCls").remove();
      if ($(tempTxt).html() != null && $(tempTxt).html() != "" && $(tempTxt).html() != undefined) {
        agDurationTxt = $($(tempTxt).html()).text().trim().replace(/\t/g, '').replace(/\n/g, '');
      }
      agDurationTxt = agDurationTxt.trim().replace(/^(.*)&nbsp;$/g, '$1');
      return agDurationTxt;
    } else {
      return "";
    }
  }
  //Method to get assignedto as a List
  trimAssignedToList(obj: HTMLElement, status: any) {
    var assignedToList: any = [];
    obj.querySelectorAll(".atwho-inserted").forEach((elem: any, elemIndex: any) => {
      var jsonObj: any = {
        "fkCodelstStatus": status,
        "ownerName": elem.innerText
      };
      if (this.utilService.nvl(elem.getAttribute("id")) != "") {
        jsonObj["fkSecUserOwner"] = parseInt(elem.getAttribute("id"));
      }
      assignedToList.push(jsonObj);
    });
    return JSON.stringify(assignedToList);
  }

  //Method to get assignedto
  trimAssignedToAI(obj: HTMLElement) {
    var assignedTo = "";
    obj.querySelectorAll(".atwho-inserted").forEach(elem => {
      assignedTo += elem.getAttribute("id") + ",";
    });
    assignedTo = this.utilService.removeLastString(assignedTo, ",");
    return assignedTo;
  }
  //Method to get assignedto
  guestAssignedToAI(obj: HTMLElement) {
    var assignedTo = "";
    obj.querySelectorAll(".atwho-inserted").forEach(elem => {
      if (elem.getAttribute("id") == "" || elem.getAttribute("id") == "null") {
        assignedTo += elem.textContent + ",";
      }
    });
    assignedTo = this.utilService.removeLastString(assignedTo, ",");
    return assignedTo;
  }

  //Method to get duedate for action Item
  trimActionItemDueDate(obj: any) {
    if ($(obj).find(".minDateCls").length != 0) {
      var dueDateTxt = "";
      var jHtmlObject = $(($(obj).find(".minDateCls:last")[0].outerHTML).replace(/[\u200B-\u200D\uFEFF\u200E\u200F]/g, '').replace(/\t/g, '').replace(/\n/g, ''));
      var tempTxt = $("<p>").append(jHtmlObject);
      tempTxt.find(".taskTimezoneCls").remove();
      tempTxt.find(".dueLabelCls").remove();
      tempTxt.find(".ui-datepicker-inline").remove();
      if ($(tempTxt).html() != null && $(tempTxt).html() != "" && $(tempTxt).html() != undefined) {
        dueDateTxt = $($(tempTxt).html()).text().trim().replace(/\t/g, '').replace(/\n/g, '');
      }
      dueDateTxt = dueDateTxt.trim().replace(/^(.*)&nbsp;$/g, '$1');
      if (dueDateTxt.length != 12) {
        dueDateTxt = "";
      }
      return dueDateTxt;
    } else {
      return "";
    }
  }

  //Method to get assignedto as a List
  trimAgPresenterList(obj: HTMLElement) {
    //
    var agPresenterList: any = [];
    if($(obj).length!=0){
      $(obj).find(".atwho-inserted").each((index: any, elem: any) => {
        var jsonObj: any = {};
        if (this.utilService.nvl($(elem).attr("fkuserid")) != "") {
          var id :any= $(elem).attr("fkuserid");
          jsonObj["presenterUserId"] = parseInt(id);
        }
        if (this.utilService.nvl($(elem).text()) != "") {
          jsonObj["presenterName"]=this.utilService.removeLastString($(elem).text().trim(),",")
        }
        agPresenterList.push(jsonObj);
      });
    }
    return agPresenterList;
  }
  //Method to get note desc for note/decision/task
  trimNoteDesc(obj: any, code: any, textFlag: any) {
    var actualTitle = "<br/>";
    if ($(obj).html() != null && $(obj).html() != "" && $(obj).html().trim() != "" && $(obj).html() != undefined && $(obj).length != 0) {
      var jHtmlObject = $($(obj)[0].outerHTML);
      var tempTxt = $("<p>").append(jHtmlObject);
      if (code == "AI") {
        tempTxt.find(".minDateCls").remove();
        tempTxt.find(".dueLabelCls").remove();
        tempTxt.find(".assignCls").remove();
        tempTxt.find(".atwho-inserted").remove();
        tempTxt.find(".taskTimezoneCls").remove();
      } else if (code == "AG") {
        tempTxt.find(".atwho-inserted").remove();
        tempTxt.find(".presentedByCls").remove();
        tempTxt.find(".agDurCls").remove();
      } else {
        tempTxt.find(".minDateCls").removeClass("hasDatepicker");
      }
      tempTxt.find(".ui-datepicker-inline").remove();
      tempTxt.find(".hoverRemoveComCls").remove();
      tempTxt.find('div[data-cke-filler-webkit]').remove();
      if (tempTxt.children('div').length > 0 && tempTxt.children('div').attr("data-cke-hidden-sel") != null) {
        tempTxt.find('div').remove();
      }
      if ($(tempTxt).html() != null && $(tempTxt).html() != "" && $(tempTxt).html() != undefined) {
        if (code == "AG" || textFlag == "Y") {
          actualTitle = $($(tempTxt).html()).html().trim().replace(/\t/g, '').replace(/\n/g, '');
        } else {
          actualTitle = $($(tempTxt).html()).html().replace(/\t/g, '').replace(/\n/g, '');
        }
      }
      if (actualTitle.trim() == "") {
        if (textFlag == "Y") {
          actualTitle = "";
        } else {
          actualTitle = "<br/>";
        }
      } else {
        actualTitle = actualTitle.trim().replace(/^(.*)&nbsp;$/g, '$1')
      }
      if ($(tempTxt).find(".min_img_comn_cls").length > 0) {
        actualTitle = this.toParseImgNoteDesc(actualTitle);
      }
      if (actualTitle.trim() != "<br>" && this.utilService.stringEndsWith(actualTitle.trim(), "<br>")) {
        actualTitle = this.utilService.removeLastString(actualTitle.trim(), "<br>");
      }

      //added for removing unwanted br tag
      actualTitle = actualTitle.replace("<br type=\"_moz\">","");
      //close
      return actualTitle;
    } else {
       //added for removing unwanted br tag
       actualTitle = actualTitle.replace("<br type=\"_moz\">","");
       //close
      return actualTitle;
    }
  }
  /* Method to replace double quotes to single related to image construction html without affecting actulal quotes */
  toParseImgNoteDesc(originalNoteDesc: any) {
    if (originalNoteDesc != "") {
      var tempTxt = $("<p>").append(originalNoteDesc);
      tempTxt.find(".min_img_comn_cls").wrap("<quote></quote>");
      var divString = $(tempTxt).html().trim();
      var arr = divString.split("</quote>");
      var noteDesc = "";
      $.each(arr, function (index: any, value: any) {
        var tempStr = value;
        if (tempStr.indexOf('<quote>') != -1) {
          var orinTxt = tempStr.substring(tempStr.indexOf('<quote>') + 7, tempStr.length);
          var newReplace = orinTxt.replace(/"/g, "'");;
          tempStr = tempStr.replace(orinTxt, newReplace);
        }
        tempStr = tempStr.replace(/<quote>/g, "");;
        noteDesc += tempStr;
      });
      originalNoteDesc = noteDesc;
    }
    return originalNoteDesc;
  }

  
  

}
